import * as React from 'react';

import styles from './appCheckboxField.module.scss';
import { AppFormField, AppFormFieldProps } from './appFormField';

export class AppCheckboxField extends AppFormField {
  protected renderInput(field: AppFormFieldProps): JSX.Element {
    return (
      <input
        {...field.input}
        type="checkbox"
        checked={field.input.value === '' ? this.props.value : field.input.value}
        disabled={this.props.disabled}
        className={styles.checkbox}
        value={this.props.value}
      />
    );
  }
}
